module.exports = __webpack_public_path__ + "img/logo.ae69544.png";